import { Variants } from "framer-motion";

export const ANIMATION_TYPES = {
  SLIDE: "slide",
} as const;

export type AnimationType = (typeof ANIMATION_TYPES)[keyof typeof ANIMATION_TYPES];

interface AnimationConfig {
  variants: Variants;
}

export const ANIMATION_TYPE_CONFIG: Record<AnimationType, AnimationConfig> = {
  [ANIMATION_TYPES.SLIDE]: {
    variants: {
      enter: (direction: number) => ({
        x: direction * 100,
        opacity: 0,
      }),
      center: {
        x: 0,
        opacity: 1,
        transition: {
          type: "spring",
          stiffness: 300,
          damping: 30,
          opacity: { duration: 0.2 },
        },
      },
      exit: (direction: number) => ({
        x: direction * -100,
        opacity: 0,
        transition: { duration: 0.2, ease: "easeInOut" },
      }),
    },
  },
};
